import React from 'react';
import GridStyledList from 'components/GridStyledList';

import image1 from 'images/content/icons/Affordable-Insurance-Plans.png'
import image2 from 'images/content/icons/Straightforward-Underwriting-Process.png'
import image3 from 'images/content/icons/Quality-Customer-Service.png'
import image4 from 'images/content/icons/Critical-Illness-Health-Coverage.png'
import image5 from 'images/content/icons/Simple-Comparison-Shopping.png'
import image6 from 'images/content/icons/Automatic-Re-Enrollment.png'

const FirstSection = () => {

    const header = 'A More Personalized Approach to Health Insurance'

    const sixthSectionContent = [
        {
            icon: image1,
            title: 'Affordable Insurance Plans',
            body: 'You save up to 50 percent on health insurance premiums throughout the year. You don’t have to pay top dollar to get the quality health insurance you and your family deserve.'
        },
        {
            icon: image2,
            title: 'Straightforward Underwriting Process',
            body: 'We match your individual, family, or group health insurance needs with the right insurance plan. Our underwriting process is simple and straightforward, saving you time and money.'
        },
        {
            icon: image3,
            title: 'Quality Customer Service',
            body: 'We are here during the moments when you need us the most. From enrollment to processing your claims, you can count on our reliable customer service from qualified health insurance brokers.'
        },
        {
            icon: image1,
            title: 'Teladoc Services',
            body: 'You have 24/7 unlimited phone access to physicians. If prescriptions are necessary, the physician will send it to your pharmacy. Get access to Teladoc’s network by phone or online.'
        },
        {
            icon: image4,
            title: 'Critical Illness Health Coverage',
            body: 'We ease the financial pressure of medical costs by providing a lump sum cash benefit directly to you during diagnosis or treatment. That way you receive compensation faster.'
        },
        {
            icon: image5,
            title: 'Simple Comparison Shopping',
            body: 'Comparing insurance companies should not have to be so difficult. To make it easy, we compare health insurance options to find a policy that meets your needs within your budget.'
        },
        {
            icon: image6,
            title: 'Automatic Re-Enrollment',
            body: 'To ensure that you have the insurance coverage you need at all times, we automatically re-enroll you annually. You receive a notification in advance to review and approve the renewal.'
        },
        {
            icon: image4,
            title: 'Karis360',
            body: 'The Karis team of experts focus on reducing the policyholder’s out-of-pocket portion of medical bills after insurance benefits have been applied, if applicable.'
        }
    ]

  return (
    <GridStyledList content={sixthSectionContent} header={header} />
  );
}

export default FirstSection;
